<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<a id="page_iii"></a>
<h1 class="title"><span class="bold">JOACHIM PEIPER AND THE NAZI ATROCITIES OF 1944</span></h1>
<p class="author">STEPHEN WYNN</p>
<div class="img_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?3d743956